import React, { useEffect } from "react";

/**
 * /pitch — investor pitch page.
 *
 * The canonical pitch deck lives at /pitch-deck.html (a static, 13-slide
 * polished file in frontend/public/). The /pitch route is kept for
 * back-compat with every place we've ever shared the short URL (emails,
 * social, biz cards), and it redirects to the canonical file so both
 * URLs always serve identical content. Update pitch-deck.html → both
 * URLs reflect it automatically.
 */
const PITCH_DECK_URL = "/pitch-deck.html";

const Pitch = () => {
  useEffect(() => {
    // Hard redirect (not Link/Navigate) because /pitch-deck.html is a
    // static file served outside the React Router tree.
    window.location.replace(PITCH_DECK_URL);
  }, []);

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-[#FFFAF7] text-[#2C2123] px-6 text-center"
      data-testid="pitch-redirect"
    >
      <div>
        <p className="font-serif italic text-2xl mb-3">Loading the pitch deck…</p>
        <p className="text-sm text-[#5C4B51]">
          If you aren't redirected,{" "}
          <a
            href={PITCH_DECK_URL}
            className="underline text-[#9B6A6C] hover:text-[#805557]"
            data-testid="pitch-redirect-fallback-link"
          >
            open it here
          </a>
          .
        </p>
      </div>
    </div>
  );
};

export default Pitch;
